import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardComponent } from './dashboard.component';
import { Routes, RouterModule } from '@angular/router';
import { StatusCardComponent } from './status-card/status-card.component';
import { ProgressComponent } from './progress/progress.component';
import { DashboardService } from './dashboard.service';
import { ZestCommonModule } from '../common/common.module';
import { MerchantsCardComponent } from './merchants-card/merchants-card.component';
import { FormsModule } from '@angular/forms';
import { MaterializeModule } from 'angular2-materialize';
import { UploadCardComponent } from './upload-card/upload-card.component';
import { LoansModule } from '../loans/loans.module';
import { CashCreditModule } from 'app/cash-credit/cash-credit.module';
import { OfflineGcModule } from 'app/offline-gc/offline-gc.module';
import { FaqsCardComponent } from './faqs-card/faqs-card.component';
import { ApiDataService } from './api-data.service';
import { LoanStatusCardComponent } from './loan-status-card/loan-status-card.component';
import { LoanListComponent } from './loan-list/loan-list.component';
import { HowToRedeemCardComponent } from './how-to-redeem-card/how-to-redeem-card.component';
import { DeclinedCardComponent } from './declined-card/declined-card.component';
import { VoucherListComponent } from './voucher-list/voucher-list.component';
import { FilesModule } from 'app/files/files.module';
import { UpdateLoanComponent } from './update-loan/update-loan.component';
import { TextMaskModule } from 'angular2-text-mask';
import { RupeeCurrencyPipe } from 'app/common/pipes';
import { TncCardComponent } from './tnc-card/tnc-card.component';
import { ClIncreaseCardComponent } from './cl-increase-card/cl-increase-card.component';
import { DashboardResolveService } from './dashboard-resolve.service';

const dashboardRoutes: Routes = [
  {
    path: '',
    component: DashboardComponent
  },
  {
    path: ':status',
    component: DashboardComponent
  }
];

@NgModule({
  imports: [
    FormsModule,
    CommonModule,
    ZestCommonModule,
    MaterializeModule,
    LoansModule,
    CashCreditModule,
    OfflineGcModule,
    FilesModule,
    TextMaskModule,
    RouterModule.forChild(dashboardRoutes),
  ],
  declarations: [
    DashboardComponent,
    StatusCardComponent,
    ProgressComponent,
    MerchantsCardComponent,
    UploadCardComponent,
    FaqsCardComponent,
    LoanStatusCardComponent,
    LoanListComponent,
    HowToRedeemCardComponent,
    DeclinedCardComponent,
    VoucherListComponent,
    UpdateLoanComponent,
    TncCardComponent,
    ClIncreaseCardComponent
  ],
  providers: [
    DashboardService,
    ApiDataService,
    RupeeCurrencyPipe,
    DashboardResolveService
  ]
})
export class DashboardModule { }


